import HundredBricksAPIError from '../../../HundredBricksAPIError';
class PropertyHealthError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PropertyHealthError', ...args);
    }
}
export default PropertyHealthError;
